import React from "react";
import { RequireStaff } from "@/components/RequireStaff";
import { CallCenterPanel, AgentCallSettings } from "@/components/call-center";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Phone, Settings } from "lucide-react";

export default function StaffCalls() {
  return (
    <RequireStaff>
      <div className="font-['Geist',sans-serif] h-full">
        <Tabs defaultValue="calls" className="h-full flex flex-col">
          <div className="flex items-center justify-between mb-4">
            <h1 className="text-xl font-semibold">Centre d'appels</h1>
            <TabsList>
              <TabsTrigger value="calls" className="gap-2">
                <Phone className="h-4 w-4" />
                Appels
              </TabsTrigger>
              <TabsTrigger value="settings" className="gap-2">
                <Settings className="h-4 w-4" />
                Paramètres
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="calls" className="flex-1 mt-0">
            <CallCenterPanel className="h-full" />
          </TabsContent>

          <TabsContent value="settings" className="mt-0">
            <div className="max-w-2xl">
              <AgentCallSettings />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </RequireStaff>
  );
}
